import { render, staticRenderFns } from "./configurationFirstAdd.vue?vue&type=template&id=263fb4a0&scoped=true&"
import script from "./configurationFirstAdd.vue?vue&type=script&lang=js&"
export * from "./configurationFirstAdd.vue?vue&type=script&lang=js&"
import style0 from "./configurationFirstAdd.vue?vue&type=style&index=0&id=263fb4a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263fb4a0",
  null
  
)

export default component.exports